// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.EyeglassLensMeasurementResponse */
/* istanbul ignore next */
@GandalfModel
export class EyeglassLensMeasurementResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	baseCurve!: number | null;

	@GandalfProperty({ designType: Number })
	blankSize!: number | null;

	@GandalfProperty({ designType: Number })
	monocularPdDistance!: number | null;

	@GandalfProperty({ designType: Number })
	monocularPdNear!: number | null;

	@GandalfProperty({ designType: Number })
	opticalCenter!: number | null;

	@GandalfProperty({ designType: Number })
	segHeight!: number | null;

	@GandalfProperty({ designType: Number })
	vertexDistance!: number | null;

}
